var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('after-sales',{attrs:{"type":"return","after-sales-number":_vm.returnNumber}})}
var staticRenderFns = []

export { render, staticRenderFns }